"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _Clips = _interopRequireDefault(require("./Clips"));

var _Marker = _interopRequireDefault(require("./Marker"));

var _DragHandler = _interopRequireDefault(require("./DragHandler"));

var _Timestamps = _interopRequireDefault(require("./Timestamps"));

require("../styles/_timeline.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Timeline(_ref) {
  var timelineZoomSeconds = _ref.timelineZoomSeconds,
      topClips = _ref.topClips,
      bottomClips = _ref.bottomClips,
      onClipDrop = _ref.onClipDrop,
      onOverrideCurrentTime = _ref.onOverrideCurrentTime,
      handleClipResize = _ref.handleClipResize,
      onDeleteClip = _ref.onDeleteClip,
      onSnapClip = _ref.onSnapClip,
      onSnapMultipleClips = _ref.onSnapMultipleClips,
      canUpdateVideo = _ref.canUpdateVideo;
  var hasClips = topClips.length || bottomClips.length;
  return /*#__PURE__*/_react.default.createElement(_uiKit.Drawer, {
    className: "timeline",
    size: 175,
    startOpen: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline-container"
  }, /*#__PURE__*/_react.default.createElement(_DragHandler.default, {
    onSetTime: onOverrideCurrentTime,
    timelineZoomSeconds: timelineZoomSeconds,
    cursor: "grabbing",
    canUpdateVideo: canUpdateVideo
  }, function (_ref2) {
    var onMouseDown = _ref2.onMouseDown,
        isDragging = _ref2.isDragging;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Marker.default, {
      isDragging: isDragging,
      timelineZoomSeconds: timelineZoomSeconds
    }), /*#__PURE__*/_react.default.createElement(_Timestamps.default, {
      timelineZoomSeconds: timelineZoomSeconds,
      onMouseDown: onMouseDown
    }));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline__clips"
  }, /*#__PURE__*/_react.default.createElement(_Clips.default, {
    onClipDrop: onClipDrop,
    id: "timeline-layer-upper",
    heightPercent: 30,
    clips: topClips,
    placeholder: hasClips ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "timeline__clips__top-placeholder"
    }),
    onDeleteClip: onDeleteClip,
    onSnapClip: onSnapClip,
    onSnapMultipleClips: onSnapMultipleClips,
    handleClipResize: handleClipResize,
    canUpdateVideo: canUpdateVideo
  }), /*#__PURE__*/_react.default.createElement(_Clips.default, {
    onClipDrop: onClipDrop,
    id: "timeline-layer-lower",
    heightPercent: 70,
    clips: bottomClips,
    placeholder: hasClips ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "timeline__clips__bottom-placeholder"
    }, "Drag & Drop your clips here"),
    onDeleteClip: onDeleteClip,
    onSnapClip: onSnapClip,
    onSnapMultipleClips: onSnapMultipleClips,
    handleClipResize: handleClipResize,
    canUpdateVideo: canUpdateVideo
  }))));
}

var _default = /*#__PURE__*/(0, _react.memo)(Timeline);

exports.default = _default;